import type { Room } from "sdk";
import { createResource, Show, type VoidProps } from "solid-js";
import { generateRoomIcon, roomLayersLoaded } from "@/lib/pfp";
import { getThumbFromId } from "@/media/util";

export const RoomIcon = (
	props: VoidProps<{ room: Room; pad?: number; mentionCount?: number }>,
) => {
	const size = 64;
	const pad = () => props.pad ?? 4;
	const totalSize = () => size + pad() * 2;
	const circPos = size - 4;
	const circRad = 12;
	const circPad = 6;

	const [pfp] = createResource(
		() => [props.room?.id, roomLayersLoaded()],
		async ([roomId, loaded]) => {
			if (!roomId || !loaded) return "";
			return generateRoomIcon(roomId as string);
		},
	);

	const mentionCount = () => props.mentionCount ?? 0;

	return (
		<svg
			aria-hidden="true"
			class="avatar has-status-indicator"
			viewBox={`0 0 ${totalSize()} ${totalSize()}`}
			role="img"
			style={{ "--pad": `${pad()}px` }}
			classList={{ autogenerated: !props.room?.icon }}
		>
			<defs>
				<mask id="rbox">
					<rect
						rx="6"
						width={size}
						height={size}
						x={pad()}
						y={pad()}
						fill="white"
					/>
					<circle
						cx={circPos}
						cy={circPos}
						r={circRad + circPad}
						fill="black"
					/>
				</mask>
				<mask id="rbox2">
					<rect
						rx="6"
						width={size}
						height={size}
						x={pad()}
						y={pad()}
						fill="white"
					/>
				</mask>
			</defs>
			<g mask={mentionCount() > 0 ? "url(#rbox)" : "url(#rbox2)"}>
				<Show
					when={props.room?.icon}
					fallback={
						<image
							preserveAspectRatio="xMidYMid slice"
							width={size}
							height={size}
							x={pad()}
							y={pad()}
							href={pfp() ?? ""}
						/>
					}
				>
					{(icon) => (
						<>
							<rect
								width={size}
								height={size}
								x={pad()}
								y={pad()}
								fill="oklch(var(--color-bg3))"
							/>
							<image
								// temp? i need to crop avatars properly on upload
								preserveAspectRatio="xMidYMid slice"
								width={size}
								height={size}
								x={pad()}
								y={pad()}
								href={getThumbFromId(icon(), 64)}
							/>
						</>
					)}
				</Show>
			</g>
			<Show when={mentionCount() > 0}>
				<circle
					class="mention-count"
					cx={circPos}
					cy={circPos}
					r={circRad}
					fill="oklch(54.03% 0.1759 13.16)"
				/>
				<text
					x={circPos}
					y={circPos}
					text-anchor="middle"
					dominant-baseline="central"
					font-size="16"
					font-weight="bold"
					fill="white"
				>
					{mentionCount() > 99 ? "99+" : mentionCount()}
				</text>
			</Show>
		</svg>
	);
};
